import { ReactNode } from "react";

import { BulkActionResultTabs } from "components/BulkActions/types";
import Box from "ds/components/Box";
import DrawerBody from "ds/components/Drawer/Body";
import { useDrawerContext } from "ds/components/Drawer/DrawerContext";
import TabPanel from "ds/components/TabPanel";

import { TABS_ORDER } from "../constants";
import BulkActionsDrawerResultsStepTabsTab from "./Tab";

type BulkActionsDrawerResultsStepTabsChildrenProps = {
  currentTab: BulkActionResultTabs;
};

export type GetTabLabel = Partial<Record<BulkActionResultTabs, string>>;

type BulkActionsDrawerResultsStepTabsProps = {
  currentTab: BulkActionResultTabs;
  setCurrentTab: (tab: BulkActionResultTabs) => void;
  counter: {
    [key in BulkActionResultTabs]: {
      count: number;
    };
  };
  children: (props: BulkActionsDrawerResultsStepTabsChildrenProps) => ReactNode;
  getTabLabel?: GetTabLabel;
};

const BulkActionsDrawerResultsStepBody = ({
  counter,
  currentTab,
  setCurrentTab,
  children,
  getTabLabel,
}: BulkActionsDrawerResultsStepTabsProps) => {
  const drawerId = useDrawerContext();

  return (
    <DrawerBody gap="large">
      <Box gap="medium" role="tablist">
        {TABS_ORDER.map((tab) => (
          <BulkActionsDrawerResultsStepTabsTab
            key={tab}
            currentTab={currentTab}
            setTab={setCurrentTab}
            result={tab}
            counter={counter[tab].count}
            labelOverride={getTabLabel?.[tab]}
            idPrefix={drawerId}
          />
        ))}
      </Box>
      {TABS_ORDER.map((tab) => (
        <TabPanel
          grow="1"
          key={tab}
          id={drawerId ? `${drawerId}-${tab}` : tab}
          isActive={currentTab === tab}
        >
          <Box grow="1" gap="large" direction="column">
            {children({ currentTab: tab })}
          </Box>
        </TabPanel>
      ))}
    </DrawerBody>
  );
};

export default BulkActionsDrawerResultsStepBody;
